/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { OptionValueType } from './CreatableAutocomplete';

export function isCustomOption<T>(value: string, options: OptionValueType<T>[]) {
  return options.some((option) => value !== option.label);
}

export function createCustomOption<T>(value: string, newValueCreatorFunction: (inputValue: string) => T) {
  return {
    customInputValue: value,
    label: value,
    value: newValueCreatorFunction(value),
  };
}
